































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppSettings from 'arc4u.framework.js/token/AppSettings';
import IAppSettings from 'arc4u.framework.js/token/IAppSettings';
import TokenKeys from 'arc4u.framework.js/token/TokenKeys';

import RegisterStepper from '@/components/RegisterStepper.vue'
import { mutationTypes as errorsMutationTypes } from '@/store/module/errors/mutations';

import { ApiException, CandidateRegistrationClient } from '../proxy/Prequalification.CandidateMgt.FacadeClient';
import { FormRegister } from '../types';
import { registerForm } from '../fixtures/register'

const register = namespace('register');
const errors = namespace('errors');

@Component({
  components: {
    RegisterStepper
  }
})
export default class Registration extends Vue {
  // map state/action/mutation/getter from store
  @register.State(state => state.step) currentStep: any;
  @register.State(state => state.stepMax) lastStep: any;

  @register.Mutation('next') next: any;
  @register.Mutation('back') back: any;
  @register.Mutation('gotoStep') gotoStep: any;

  @errors.Mutation(errorsMutationTypes.setErrors)
  setErrors!: (values: string[]) => void;

  // state
  registerForm: FormRegister = registerForm;
  submitLoading: boolean = false;
  validForm: boolean = false;

  get errors(): string[] {
    return this.registerForm.error.split('\n');
  }

  goBack() {
    if (this.currentStep > 1) {
      this.back();

      return;
    }

    this.$router.push('/');
  }

  async submit(e: MouseEvent) {
    e.preventDefault();

    if (this.validForm){
      this.submitLoading = true;

      try {
        this.registerForm.recaptchaToken = await this.$recaptcha('register');
      } catch {
        console.error('an error occured trying to get the ReCaptcha token');
      };

      let settings: IAppSettings = AppSettings.Get("OAuth");
      let proxy: CandidateRegistrationClient = new CandidateRegistrationClient(settings.Values.filter(v => v.Key === TokenKeys.RootServiceUrlKey)[0].Value);
      
      proxy.addCandidate(this.registerForm.candidate)
        .then(() => {
          this.submitLoading = false;
          this.$router.push({ name: 'register-thank-you' });
        })
        .catch((error) => {
          const msg: string[] = [];
          
          if (error instanceof ApiException) {
            let errors = JSON.parse(error.response)?.errors;
            if (errors) {
              Object.keys(errors).forEach(function(key,index) {
                if (errors[key] && Array.isArray(errors[key]) && errors[key].length > 0) {
                  msg.push(errors[key][0]);
                }
              });
            }
          }
        
          if (msg) {
            this.setErrors(msg);
          }
          else if (error?.message === 'ReCaptcha Failure') {
            this.setErrors(['general.captchaerror']);
          }
          else {
            this.setErrors(['general.error']);
          }
      }).finally(() => {
        this.submitLoading = false;
      });
    }
  }
}
